import React, { Suspense, useEffect, useState } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import * as actions from "./store/actions/index";

import Presentation from "./Containers/Presentation/Presentation";
import Help from "./Containers/Help/Help";
import LoginPage from "./Containers/Authentication/LoginPage/LoginPage";
import SignUpPage from "./Containers/Authentication/SignUpPage/SignUpPage";
import Logout from "./Containers/Authentication/Logout/Logout";
import ProfilePage from "./Containers/Profile/Profile";
import ManualCapture from "./Containers/ManualCapture/ManualCapture";
import Method from "./Containers/Method/Method";
import StravaActivities from "./Containers/Strava/StravaActivities";
import ForgotPasswordPage from "./Containers/ForgotPassword/ForgotPassword";

const App = (props) => {
  const { onTryAutoSignIn } = props;
  useEffect(() => {
    onTryAutoSignIn();
  }, [onTryAutoSignIn]);

  // console.log(props.authenticated);

  let routes = (
    <Switch>
      <Switch>
        <Route path="/" exact component={Presentation} />
        <Route path="/login" exact component={LoginPage} />
        <Route path="/signup" exact component={SignUpPage} />
        <Route path="/Help" exact component={Help} />
        <Route path="/ForgotPassword" exact component={ForgotPasswordPage} />

        {/* <Redirect to="/" /> */}
      </Switch>
    </Switch>
  );
  console.log("selectedEvent", props.selectedEvent);

  if (props.authenticated) {
    routes = (
      <Switch>
        <Route path="/Profile" component={ProfilePage} />
        <Route path="/logout" component={Logout} />
        <Route path="/Help" exact component={Help} />
        <Route path="/" exact component={Presentation} />
        <Redirect to="/" />
      </Switch>
    );
  }

  if (props.authenticated) {
    routes = (
      <Switch>
        <Route path="/Profile" component={ProfilePage} />
        <Route path="/logout" component={Logout} />
        <Route path="/Method" component={Method} />
        <Route path="/Help" exact component={Help} />
        <Route path="/StravaActivities" component={StravaActivities} />
        <Route path="/" exact component={Presentation} />
        Profile
        <Route
          path="/ManualCapture"
          render={(props) => <ManualCapture {...props} />}
        />
        <Redirect to="/" />
      </Switch>
    );
  }

  return (
    <div className="App">
      <Suspense fallback={<p>Loading</p>}>{routes}</Suspense>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    authenticated: state.authentication.authenticated,
    user: state.authentication.user,
    selectedEvent: state.event.selectedEvent,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onTryAutoSignIn: () => dispatch(actions.authCheckState()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
